import "./App.css";
import { ThemeProvider, Loader } from "@aws-amplify/ui-react";
import { FaceLivenessDetector } from "@aws-amplify/ui-react-liveness";
import { Amplify } from "aws-amplify";
// eslint-disable-next-line import/no-unresolved
import "@aws-amplify/ui-react/styles.css";
import awsexports from "./aws-exports";
import { useEffect, useState } from "react";
import { createNewSession, getSessionResult } from "./api";
import displayTexts from "./translations";

Amplify.configure(awsexports);

function App() {
  const [sessionId, setSessionId] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [language, setLanguage] = useState(null);
  const [baseUrl, setBaseUrl] = useState(null);

  const displayText = displayTexts[language ?? "en"];

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const preferredLanguage = urlParams.get("language");
    const apiURL = urlParams.get("api");

    setAuthToken(token);
    setLanguage(preferredLanguage);
    setBaseUrl(apiURL);

    if (token) {
      createNewSession({
        authToken: token,
        baseUrl: apiURL,
      })
        .then((data) => setSessionId(data.sessionId))
        .catch((error) => console.error("Error creating session:", error));
    }
  }, []);

  const sendMessageToNative = (response) => {
    window.ReactNativeWebView.postMessage(JSON.stringify(response));
  };

  const handleAnalysisComplete = async () => {
    if (sessionId && authToken) {
      try {
        const result = await getSessionResult({
          baseUrl,
          sessionId,
          authToken,
        });
        sendMessageToNative(result);
      } catch (error) {
        //console.error("Error getting session result:", error);
      }
    }
  };

  return (
    <ThemeProvider>
      <div className="App">
        {!sessionId ? (
          <Loader />
        ) : (
          <FaceLivenessDetector
            sessionId={sessionId}
            region="eu-west-1"
            disableStartScreen={true}
            onAnalysisComplete={handleAnalysisComplete}
            onError={(error) => {
              console.error(error);
            }}
            displayText={displayText}
            onUserCancel={() => sendMessageToNative({ status: "CLOSED" })}
          />
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
